<script>
  import { Label, Input } from "sveltestrap";
  import ColorPicker from "./colorPicker.svelte";
  import FieldPreviewer from "./fieldPreviewer.svelte";
  import { checkDashPattern, shapeTypes } from "../../editor/component/mark";
  import { currentSpec, dataInfo } from "../../editor/storage.js";
  import ExpressionEditor from "./expressionEditor.svelte";
  import FilterEditor from "./filterEditor.svelte";
  import { onMount, onDestroy } from "svelte";
  import { parseDatumObject } from "../../editor/direct.js";
  import {
    openSystemTooltip,
    closeSystemTooltip,
  } from "../../editor/utility.js";
  import CalculateEditor from "./calculateEditor.svelte";

  export let type;
  export let token;
  export let disabled = false;
  export let changeAction;
  // export let cancel;
  export let inputFocusAction;
  export let inputBlurAction;
  export let min;
  export let max;
  export let value;
  export let values;
  export let field;
  export let title;
  export let validator;
  export let pickerX = "290px";
  export let pickerY = "450px";
  export let readonly = false;
  export let tooltipMessage;
  export let step;
  // filter-json
  export let specifiedLayer;
  // orient
  export let topBottom = true;
  export let leftRight = true;
  export let tblr6pos = true;
  export let center = false;
  export let none = true;
  export let tblr4pos = true;
  export let tblr9pos = true;
  // anchor
  export let mse3pos = true;
  // seelct
  export let options = [];
  export let optionNames = [];
  // color
  export let isMarkLabel = false;
  // color picker;
  let showColorPicker = false;
  let afterPickAction;
  let pickerCurrentColor;
  function openColorPicker(action, curr) {
    showColorPicker = true;
    if (action.constructor.name === "Function") afterPickAction = action;
    pickerCurrentColor = curr;
  }
  function closeColorPicker() {
    showColorPicker = false;
    afterPickAction = undefined;
    pickerCurrentColor = undefined;
  }
  // dash pattern validate
  let invalidDashPattern;
  // name string validate
  let invalidNameString;
  // preview
  let preview = false;
  //search
  let searchOutput = [];
  let searchSelect = [];
  let candidates = [];
  let searchForm;
  let searchIntermediate = false;
  if (type === "values") {
    candidates = $dataInfo?.stats?.[field]?.values;
    searchSelect = value;
  }
  function searchMatch(ref, key, rank) {
    if (!ref) return rank ? Infinity : false;
    if (ref.startsWith(key)) return rank ? 1 : true;
    else if (ref.includes(key)) return rank ? 2 : true;
    else if (key.match(new RegExp("^[" + ref + "]+$"))?.length > 0) {
      if (rank)
        return (
          2 +
          1 /
            (ref.match(
              new RegExp("[" + key + "]+", "gi")?.reduce(
                (c, a) => a + c.length,
                0
              )
            ) || 1)
        );
      else return true;
    } else return rank ? Infinity : false;
  }
  function search(value, cands) {
    let sp = ("" + value).split(",");
    let searchKeyword = sp[sp.length - 1];
    if (!value || value?.length < 0) return false;
    return cands
      .filter((v) => {
        // update search alg if needed;
        if (searchSelect.includes(v)) return false;
        return searchMatch(v, searchKeyword, false);
      })
      .sort((a, b) => {
        return (
          searchMatch(a, searchKeyword, true) -
          searchMatch(b, searchKeyword, true)
        );
      });
  }
  let showExpressionEditor = false;
  function openExpressionEditor() {
    showExpressionEditor = true;
  }
  function closeExpressionEditor() {
    showExpressionEditor = false;
  }
  let showCalculateEditor = false;
  function openCalculateEditor() {
    showCalculateEditor = true;
  }
  function closeCalculateEditor() {
    showCalculateEditor = false;
  }
  // padding
  let padding = {};
  if (type === "boxPadding") {
    if (!value) {
      padding = {};
    } else if (value.constructor.name === "String") {
      value?.split(" ").forEach((v, i) => {
        if (i == 0) padding.top = parseFloat(v);
        else if (i == 1) padding.right = parseFloat(v);
        else if (i == 2) padding.bottom = parseFloat(v);
        else if (i == 3) padding.left = parseFloat(v);
      });
    } else if (value.constructor.name === "Array") {
      padding = {
        top: value[0],
        right: value[1],
        bottom: value[2],
        left: value[3],
      };
    } else if (value.constructor.name === "Object") {
      padding = value;
    }
  }
  // value check
  function validateUnitNumber(v) {
    // /^[-]?([1-9][0-9]*|[1-9][0-9]*\.[0-9]+|[0-9]\.[0-9]+)(px|%|cm|mm|rem|em|deg)?$/
    let n;
    if (((n = parseFloat(v)), n) !== undefined) {
      let unit = v.match(/(px|%|cm|mm|rem|em|deg)$/);
      if (unit) return n + unit[0];
      else return n + "px";
    } else {
      return "0px";
    }
  }
  let dataPickMode = false;
  let pickedData;
  export let editable = false;
  function dataPickClickFuntion(event) {
    let datumExpr = event.target.getAttribute("aria-label");
    let datum = parseDatumObject(datumExpr);
    let role =
      event.target.getAttribute("aria-roledescription")?.split(" ")?.[0] || "";
    if (Object.keys(datum).length > 0) {
      pickedData = { role, datum };
      changeAction(pickedData);
    } else {
      pickedData = undefined;
    }
    toggleDataPickMode();
  }
  function toggleDataPickMode() {
    dataPickMode = !dataPickMode;

    if (dataPickMode) {
      document
        .querySelectorAll(
          `#view-${$currentSpec.uid} g.mark-group[role="graphics-object"] path[role="graphics-symbol"]`
        )
        .forEach((d) => {
          d.addEventListener("click", dataPickClickFuntion, { once: true });
        });
    } else {
      document
        .querySelectorAll(
          `#view-${$currentSpec.uid} g.mark-group[role="graphics-object"] path[role="graphics-symbol"]`
        )
        .forEach((d) => {
          d.removeEventListener("click", dataPickClickFuntion);
        });
    }
  }
  onMount(() => {
    dataPickMode = false;
  });
  onDestroy(() => {
    dataPickMode = false;
  });
</script>

{#if type === "text"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Text"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="text"
      class="custom-form-select"
      autocomplete="off"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {readonly}
      {disabled}
    />
  </div>
{:else if type === "nameString"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Name"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="text"
      class="custom-form-select"
      autocomplete="off"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      {disabled}
      on:keyup={(event) => {
        if (validator && validator.constructor.name === "Function") {
          invalidNameString = !validator(event);
        }
      }}
      on:change={(event) => {
        if (!invalidNameString) changeAction(event);
      }}
      {readonly}
    />
  </div>
  {#if invalidNameString}
    <div class="dupo-menu-pane-row warn-msg">
      <p class="mb-0 text-sm">
        <i class="bi bi-exclamation-circle-fill me-2" /> Invalid name string
      </p>
    </div>
  {/if}
{:else if type === "longText"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Text"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="textarea"
      {min}
      {max}
      class="custom-form-select"
      autocomplete="off"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      {disabled}
      on:change={changeAction}
    />
  </div>
{:else if type === "number"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Number"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="number"
      {min}
      {max}
      class="custom-form-select"
      autocomplete="off"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      {disabled}
      on:change={changeAction}
    />
  </div>
{:else if type === "unitNumber"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Unit number"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="text"
      class="custom-form-select"
      autocomplete="off"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      {disabled}
      on:change={(event) => {
        event.target.value = validateUnitNumber(event.target.value);
        changeAction(event);
      }}
    />
  </div>
{:else if type === "values"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Values"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <textarea
      id={token}
      name={token}
      class="custom-form-select form-control"
      bind:this={searchForm}
      {disabled}
      value={searchSelect?.join(",") || ""}
      on:keyup={(event) => {
        console.log(candidates);
        searchIntermediate = true;
        searchOutput = search(event.target.value, candidates);
      }}
      on:focus={(event) => {
        inputFocusAction(event);
        searchIntermediate = false;
        searchOutput = search(event.target.value, candidates);
        preview = true;
      }}
      on:blur={(event) => {
        inputBlurAction(event);
        // todo: revise
        setTimeout(() => {
          if (document.activeElement != searchForm) {
            preview = false;
          }
        }, 3500);
      }}
      on:change={(event) => {
        searchSelect = event.target.value.split(",") || [];
        changeAction(event);
        setTimeout(() => {
          if (document.activeElement != searchForm) {
            preview = false;
          }
        }, 3500);
      }}
    />
  </div>
  {#if field && field.length > 0 && preview}
    <FieldPreviewer
      {field}
      x={pickerX}
      y={pickerY}
      selected={searchSelect}
      selectAction={(s) => {
        if (!searchSelect.includes(s)) {
          if (searchIntermediate) searchSelect[searchSelect.length - 1] = s;
          else searchSelect.push(s);
        } else searchSelect = searchSelect.filter((d) => d != s);
        document.getElementById(token).value = searchSelect?.join(",") || "";
        searchForm?.focus();
        searchForm?.dispatchEvent(new Event("change"));
        searchIntermediate = false;
      }}
      {disabled}
    />
  {/if}
{:else if ["fontSize", "width", "height", "size", "radius"].includes(type)}
  <div class="dupo-menu-pane-row">
    <Label for={token}
      >{title ||
        {
          fontSize: "Font size",
          width: "Width",
          height: "Height",
          size: "Size",
          radius: "Radius",
        }[type] ||
        "Size"}</Label
    >
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="number"
      min="0"
      class="custom-form-select"
      autocomplete="off"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    />
  </div>
{:else if type === "angle"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Angle"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="number"
      min="0"
      max="360"
      class="custom-form-select"
      autocomplete="off"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    />
  </div>
{:else if type === "fontWeight"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Font weight"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="select"
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    >
      <option value={undefined} />
      <option value="100">100 (Thin)</option>
      <option value="200">200 (Extralight)</option>
      <option value="300">300 (Light)</option>
      <option value="400">400 (Regular)</option>
      <option value="500">500 (Medium)</option>
      <option value="600">600 (Demibold)</option>
      <option value="700">700 (Bold)</option>
      <option value="800">800 (Extrabold)</option>
      <option value="900">900 (Heavy)</option>
    </Input>
  </div>
{:else if type === "textOverflow"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Text overflow"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="select"
      class="custom-form-select"
      autocomplete="off"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    >
      <option value={undefined} />
      <option value="epllipsis">Ellipsis (...)</option>
      <option value="hidden">Hidden</option>
      <option value="visible">Visible</option>
    </Input>
  </div>
{:else if type === "strokeStyle"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Stroke style"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="select"
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    >
      <option value={undefined} />
      <option value="solid">Solid</option>
      <option value="dotted">Dotted</option>
      <option value="dashed">Dashed</option>
    </Input>
  </div>
{:else if type === "orient"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Orient"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="select"
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    >
      <option value={undefined} />
      {#if topBottom}
        <option value="top">Top</option>
        <option value="bottom">Bottom</option>
      {/if}
      {#if leftRight}
        <option value="left">Left</option>
        <option value="right">Right</option>
      {/if}
      {#if center}
        <option value="center">Center</option>
      {/if}
      {#if tblr9pos || tblr6pos || tblr4pos}
        <option value="top-left">Top-left</option>
        {#if tblr9pos || tblr6pos}
          <option value="top-center">Top-center</option>
        {/if}
        <option value="top-right">Top-right</option>
        {#if tblr9pos}
          <option value="middle-left">Middle-left</option>
          <option value="middle-center">Middle-center</option>
          <option value="middle-right">Middle-right</option>
        {/if}
        <option value="bottom-left">Bottom-left</option>
        {#if tblr9pos || tblr6pos}
          <option value="bottom-center">Bottom-center</option>
        {/if}
        <option value="bottom-right">Bottom-right</option>
      {/if}
      {#if none}
        <option value="none">Manual positioning</option>
      {/if}
    </Input>
  </div>
{:else if type === "anchor"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Anchor"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="select"
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    >
      <option value={undefined} />
      {#if mse3pos}
        <option value="start">Start</option>
        <option value="middle">Middle</option>
        <option value="end">End</option>
      {/if}
    </Input>
  </div>
{:else if type === "opacity"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Opacity"}</Label><span class="ms-1"
      >{value}</span
    >
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="range"
      min={min || 0}
      max={max || 1}
      step="0.01"
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    />
  </div>
{:else if type === "slider"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Value"}</Label><span class="ms-1"
      >{value}</span
    >
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="range"
      min={min || 0}
      max={max || 1}
      step={step || 1}
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    />
  </div>
{:else if type === "color"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Color"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <div class="custom-form-select">
      <div class="d-inline-block ps-2 pe-1">
        <i
          class="bi bi-square-fill"
          style={`color: ${value || "black"}`}
          alt={`A color chip for ${value || "black"}`}
        />
      </div>
      <span class="d-inline-block color-name">{value || ""}</span>
      <div
        class="d-inline-block px-1"
        on:click={() => {
          if (!disabled) {
            openColorPicker((event) => {
              changeAction(event);
            }, value || "rgba(0,0,0,1)");
          }
        }}
      >
        <i class="bi bi-paint-bucket" alt="pick color" />
      </div>
    </div>
  </div>
  {#if isMarkLabel}
    <div class="dupo-menu-pane-form-row mt-2">
      <div class="form-wrap">
        <button
          type="button"
          class={"custom-form-select" + (value === "$mark" ? " selected" : "")}
          on:click={changeAction}
          value="$mark">Mark color</button
        >
        <button
          type="button"
          class={"custom-form-select" +
            (value === "$black-white" ? " selected" : "")}
          on:click={changeAction}
          value="$black-white">White/black</button
        >
      </div>
    </div>
  {/if}
{:else if type === "dash"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Dash"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      type="text"
      class="custom-form-select"
      id={token}
      name={token}
      {value}
      autocomplete="off"
      {disabled}
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      on:keyup={(event) => {
        invalidDashPattern = !checkDashPattern(event.target.value);
      }}
      on:change={(event) => {
        if (!invalidDashPattern) changeAction(event);
      }}
    />
  </div>
  {#if invalidDashPattern}
    <div class="dupo-menu-pane-row warn-msg">
      <p class="mb-0 text-sm">
        <i class="bi bi-exclamation-circle-fill me-2" /> Invalid dash array
      </p>
    </div>
  {/if}
{:else if type === "textAlign"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Text align"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <div class="form-wrap">
      <button
        type="button"
        class={"custom-form-select" + (value === "left" ? " selected" : "")}
        on:click={(event) => {
          if (event.target.tagName === "I")
            changeAction({ target: event.target.parentElement });
          else changeAction(event);
        }}
        value="left"
        style="width: 33%;"
        {disabled}
      >
        <i class="bi bi-text-left" alt="left alignment" />
      </button>
      <button
        type="button"
        class={"custom-form-select" + (value === "center" ? " selected" : "")}
        on:click={(event) => {
          if (event.target.tagName === "I")
            changeAction({ target: event.target.parentElement });
          else changeAction(event);
        }}
        value="center"
        style="width: 34%;"
        {disabled}
      >
        <i class="bi bi-text-center" alt="center alignment" />
      </button>
      <button
        type="button"
        class={"custom-form-select" + (value === "right" ? " selected" : "")}
        on:click={(event) => {
          if (event.target.tagName === "I")
            changeAction({ target: event.target.parentElement });
          else changeAction(event);
        }}
        value="right"
        style="width: 33%;"
        {disabled}
      >
        <i class="bi bi-text-right" alt="right alignment" />
      </button>
    </div>
  </div>
{:else if type === "boxPadding"}
  <div class="dupo-menu-pane-row">
    <Label>{title || "Padding"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row" style="margin-bottom: -0.5rem;">
    <div class="form-wrap">
      <Label
        for="padding-top"
        class="text-sm"
        style="width: 25%; padding-left: 0.5rem;">Top</Label
      >
      <Label
        for="padding-bottom"
        class="text-sm"
        style="width: 25%; padding-left: 0.5rem;">Bottom</Label
      >
      <Label
        for="padding-left"
        class="text-sm"
        style="width: 25%; padding-left: 0.5rem;">Left</Label
      >
      <Label
        for="padding-right"
        class="text-sm"
        style="width: 25%; padding-left: 0.5rem;">Right</Label
      >
    </div>
  </div>
  <div class="dupo-menu-pane-form-row">
    <div class="form-wrap">
      <Input
        id="padding-top"
        name="padding-top"
        type="number"
        class="custom-form-select"
        autocomplete="off"
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
        on:change={changeAction}
        value={padding.top}
        style="width: 25%;"
        {disabled}
      />
      <Input
        id="padding-bottom"
        name="padding-bottom"
        type="number"
        class="custom-form-select"
        autocomplete="off"
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
        on:change={changeAction}
        value={padding.bottom}
        style="width: 25%;"
        {disabled}
      />
      <Input
        id="padding-left"
        name="padding-left"
        type="number"
        class="custom-form-select"
        autocomplete="off"
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
        on:change={changeAction}
        value={padding.left}
        style="width: 25%;"
        {disabled}
      />
      <Input
        id="padding-right"
        name="padding-right"
        type="number"
        class="custom-form-select"
        autocomplete="off"
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
        on:change={changeAction}
        value={padding.right}
        style="width: 25%;"
        {disabled}
      />
    </div>
  </div>
{:else if type === "inline-check"}
  <div class="dupo-menu-pane-form-row form-inline">
    {#if tooltipMessage}
      <Label
        data-for={token}
        class="check-label"
        on:mouseover={function (event) {
          openSystemTooltip(event, tooltipMessage);
        }}
        on:mousemove={function (event) {
          openSystemTooltip(event, tooltipMessage);
        }}
        on:focus={function (event) {
          openSystemTooltip(event, tooltipMessage);
        }}
        on:blur={() => closeSystemTooltip()}
        on:mouseout={() => closeSystemTooltip()}>{title || "Check"}</Label
      >
    {:else}
      <Label data-for={token} class="check-label">{title || "Check"}</Label>
    {/if}

    <Input
      id={token}
      name={token}
      type="checkbox"
      class="me-1"
      checked={value}
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      on:change={changeAction}
      {disabled}
    />
  </div>
{:else if type === "data-expression"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Expression"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="textarea"
      autocomplete="off"
      readonly
      class="custom-form-select"
      {value}
      on:focus={() => {
        openExpressionEditor();
      }}
      {disabled}
    />
  </div>
  <!-- on:change={changeAction} -->
  {#if showExpressionEditor}
    <ExpressionEditor
      {inputFocusAction}
      {inputBlurAction}
      {changeAction}
      {specifiedLayer}
      closer={closeExpressionEditor}
      {value}
      {values}
      {field}
      subTitle="mark label"
    />
  {/if}
{:else if type === "filter-json"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Filter"}</Label>
  </div>
  {#if !value}
    <div class="dupo-menu-pane-button-row">
      <button
        id="confirm-filter-new"
        {disabled}
        on:click={() => {
          openExpressionEditor();
        }}><i class="bi bi-plus-circle me-1" />Add</button
      >
    </div>
  {:else}
    <div class="dupo-menu-pane-form-row">
      <Input
        id={token}
        name={token}
        type="textarea"
        readonly
        class="custom-form-select filter-statement text-sm"
        {disabled}
        value={value?.constructor.name === "Object"
          ? JSON.stringify(value)
          : value || ""}
        on:focus={() => {
          openExpressionEditor();
        }}
      />
    </div>
  {/if}
  <!-- on:change={changeAction} -->
  {#if showExpressionEditor}
    <FilterEditor
      {inputFocusAction}
      {inputBlurAction}
      value={value?.constructor.name === "Object"
        ? JSON.stringify(value)
        : value || ""}
      closer={closeExpressionEditor}
      {specifiedLayer}
      changeAction={changeAction ||
        ((event) => {
          if (
            (event.target.value.startsWith("{") &&
              event.target.value.endsWith("}")) ||
            (event.target.value.startsWith("[") &&
              event.target.value.endsWith("]"))
          )
            value = JSON.parse(event.target.value);
          else value = event.target.value;
        })}
    />
  {/if}
{:else if type === "field-calculate"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Calculate"}</Label>
  </div>
  {#if !value}
    <div class="dupo-menu-pane-button-row">
      <button
        id="confirm-filter-new"
        {disabled}
        on:click={() => {
          openCalculateEditor();
        }}><i class="bi bi-plus-circle me-1" />Add</button
      >
    </div>
  {:else}
    <div class="dupo-menu-pane-form-row">
      <Input
        id={token}
        name={token}
        type="textarea"
        readonly
        class="custom-form-select filter-statement text-sm"
        {disabled}
        value={value.expression}
        on:focus={() => {
          openCalculateEditor();
        }}
      />
    </div>
    <div
      class="dupo-menu-pane-form-row mt-1"
      style="display: flex; justify-content: space-between;"
    >
      <span class="pt-1">As</span>
      <Input
        id={token}
        name={token}
        type="text"
        readonly
        class="custom-form-select filter-statement text-sm"
        style="width: 80%"
        {disabled}
        value={value.as}
        on:focus={() => {
          openCalculateEditor();
        }}
      />
    </div>
  {/if}
  <!-- on:change={changeAction} -->
  {#if showCalculateEditor}
    <CalculateEditor
      {inputFocusAction}
      {inputBlurAction}
      {value}
      {specifiedLayer}
      closer={closeCalculateEditor}
      {changeAction}
    />
  {/if}
{:else if type === "data-object"}
  <div class="dupo-menu-pane-row">
    <Label>{title || "Filter"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    {#if pickedData}
      <div class="form-wrap" style="margin-bottom: 0.1rem;">
        <Input type="text" class="custom-form-select" value={"Mark"} readonly />
        <Input
          type="text"
          class="custom-form-select un-readonly"
          value={pickedData.role}
          readonly
          {disabled}
        />
      </div>
      {#each Object.keys(pickedData?.datum || {}) as key}
        <div class="form-wrap" style="margin-bottom: 0.1rem;">
          <Input type="text" class="custom-form-select" value={key} readonly />
          <Input
            type="text"
            class="custom-form-select un-readonly"
            value={pickedData.datum[key]}
            readonly
          />
          {#if editable}
            <button
              type="button"
              class="custom-form-select btn-x"
              {disabled}
              on:click={() => {
                delete pickedData.datum[key];
                changeAction(pickedData);
              }}><i class="bi bi-x" /></button
            >
          {/if}
        </div>
      {/each}
    {:else if value?.constructor.name === "Object"}
      <div class="form-wrap" style="margin-bottom: 0.1rem;">
        <Input type="text" class="custom-form-select" value={"Mark"} readonly />
        <Input
          type="text"
          class="custom-form-select un-readonly"
          value={value.role}
          readonly
          {disabled}
        />
      </div>
      {#each Object.keys(value.datum || {}) as key}
        <div class="form-wrap" style="margin-bottom: 0.1rem;">
          <Input type="text" class="custom-form-select" value={key} readonly />
          <Input
            type="text"
            class="custom-form-select un-readonly"
            value={value.datum[key]}
            readonly
            {disabled}
          />
          {#if editable}
            <button
              type="button"
              class="custom-form-select btn-x"
              {disabled}
              on:click={() => {
                delete value.datum[key];
                changeAction(value);
              }}><i class="bi bi-x" /></button
            >
          {/if}
        </div>
      {/each}
    {/if}
  </div>
  <div class="dupo-menu-pane-form-row">
    {#if dataPickMode}
      <button
        type="button"
        class="custom-form-select selected"
        {disabled}
        on:click={() => {
          toggleDataPickMode();
        }}><i class="bi bi-link-45deg me-1" /> Click a mark!</button
      >
    {:else}
      <button
        type="button"
        class="custom-form-select"
        {disabled}
        on:click={() => {
          toggleDataPickMode();
        }}><i class="bi bi-link-45deg me-1" /> Pick data</button
      >
    {/if}
  </div>
{:else if type === "select"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Select"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="select"
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    >
      <option value={undefined} />
      {#each options as opt, i}
        <option value={opt}>{optionNames[i] || opt}</option>
      {/each}
    </Input>
  </div>
{:else if type === "shape"}
  <div class="dupo-menu-pane-row">
    <Label for={token}>{title || "Shape"}</Label>
  </div>
  <div class="dupo-menu-pane-form-row">
    <Input
      id={token}
      name={token}
      type="select"
      class="custom-form-select"
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      {value}
      on:change={changeAction}
      {disabled}
    >
      <option value={undefined} />
      {#each shapeTypes as shapeName}
        <option value={shapeName}>{shapeName}</option>
      {/each}
    </Input>
  </div>
{:else if type === "lock"}
  <div class="dupo-menu-pane-form-row form-inline">
    {#if tooltipMessage !== undefined}
      <!-- Ignore the warning! this is intended. will eventually work -->
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label
        data-for={token}
        class="check-label form-label"
        on:mouseover={function (event) {
          openSystemTooltip(event, tooltipMessage);
        }}
        on:mousemove={function (event) {
          openSystemTooltip(event, tooltipMessage);
        }}
        on:focus={function (event) {
          openSystemTooltip(event, tooltipMessage);
        }}
        on:blur={() => closeSystemTooltip()}
        on:mouseout={() => closeSystemTooltip()}>{title || "Lock"}</label
      >
    {:else}
      <Label data-for={token} class="check-label x">{title || "Lock"}</Label>
    {/if}
    <Input
      id={token}
      name={token}
      type="checkbox"
      class="me-1"
      checked={value}
      {disabled}
      on:focus={inputFocusAction}
      on:blur={inputBlurAction}
      on:change={changeAction}
    />
  </div>
{/if}

<!-- color picker -->
{#if showColorPicker}
  <ColorPicker
    x={pickerX}
    y={pickerY}
    color={pickerCurrentColor}
    afterPick={afterPickAction}
    closer={closeColorPicker}
  />
{/if}

<style>
  button.custom-form-select.selected {
    background-color: #ffea9c !important;
  }
  :global(input.custom-form-select[type="range"]) {
    overflow: hidden;
  }
  :global(input.custom-form-select[type="range"]::-webkit-slider-thumb) {
    background-color: #ffc422;
  }
  :global(.filter-statement[readonly]),
  :global(.filter-statement[disabled]),
  :global(.un-readonly[readonly]) {
    background-color: #ffffff !important;
  }
  button.custom-form-select.btn-x {
    width: 2rem !important;
    background-color: #ffeeee !important;
  }
</style>
